import { createRoot } from 'react-dom/client';
import Loader from './Loader';
/**
 * Render Loader in DOM
 * @param type
 */
const showLoader = (type, fullscreen = true) => {
	const props = {};
	const containerId = 'logo-loader';
	let container = document.getElementById(containerId);

	if (container) {
		container.parentNode.removeChild(container);
	}

	// init DOM container
	container = document.createElement('div');
	container.id = containerId;
	document.body.appendChild(container);
    const root = createRoot(container);

	// default props
	const closeFn = () => {
		if (document.getElementById(containerId)) {
			root.unmount();
		}
	};
	props.onClose = closeFn;
	root.render(<Loader {...props} type={type} fullscreen={fullscreen} />);
};

export { showLoader };
